module.exports = __webpack_public_path__ + "img/icon_map_188_on_100.58aa8ecf.png";